import React, { useState, useEffect } from 'react';
import { Checkbox, Input, InputNumber, Select, Form, Button, Tabs } from 'antd';
import { Option } from 'antd/lib/mentions';
import { Card, CardBody, Row, Col } from 'reactstrap';
import UrlProps from './UrlProps';
import JsonProps from './JsonProps';
import {
    SaveOutlined
} from '@ant-design/icons';
import { dataSoruce } from 'settings/shared/constants';
import 'components/Widgets/widget-style.css';

const { TabPane } = Tabs;

const ChartRender = (props) => {

    const { TextArea } = Input;
    const [getDataBindtype, setDataBindtype] = useState("URL");
    const [getErrorFlag, setErrorFlag] = useState(false);

    const [xaxisData, setXaxisData] = useState({
        title: "",
        prefix: "",
        suffix: ""
    })

    const [yaxisData, setYaxisData] = useState({
        title: "",
        prefix: "",
        suffix: ""
    })

    const [formChart] = Form.useForm();
    useEffect(() => {
        let widgetData = props.widgetItem !== null &&
            props.widgetItem !== undefined &&
            props.widgetItem.widgetData !== null &&
            props.widgetItem.widgetData.length > 0 &&
            props.widgetItem.widgetData[0];
        if (widgetData.hasOwnProperty("bind")) {
            formChart.setFieldsValue({
                width: widgetData.width,
                theme: widgetData.theme,
                dataFrom: widgetData.dataFrom,
                title: widgetData.title,
                markerSize: widgetData.markerSize,
                fontSize: widgetData.fontSize,
                animationAngle: widgetData.animationAngle,
                animationDuration: widgetData.animationDuration,
                chartOptions: widgetData.chartOptions,
            })
            setDataBindtype(widgetData.dataFrom);
            setXaxisData(widgetData.axisX);
            setYaxisData(widgetData.axisY);
        } else {
            formChart.setFieldsValue({
                title: "",
                theme: "light1",
                width: 40,
                markerSize: 6,
                fontSize: 12,
                animationAngle: 50,
                animationDuration: 2,
                chartOptions: [],
                dataFrom: "URL"
            })
            setDataBindtype("URL");
        }

    }, [props]);

    const onChangeDataBind = (e) => {
        setDataBindtype(e)
    };

    const xAxisonChange = (e) => {
        const { name, value } = e.target;
        let xaxisItem = xaxisData;
        let keys = Object.keys(xaxisItem)
        keys.map(x => {
            xaxisItem[name] = value;
        })
        setXaxisData(
            prev => {
                return { ...prev, xaxisItem };
            });
    }

    const yAxisonChange = (e) => {
        const { name, value } = e.target;
        let yaxisItem = yaxisData;
        let keys = Object.keys(yaxisItem)
        keys.map(x => {
            yaxisItem[name] = value;
        })
        setYaxisData(
            prev => {
                return { ...prev, yaxisItem };
            });
    }

    const onFinish = () => {
        let forms = formChart.getFieldValue();
        if (forms.hasOwnProperty("bind")) {
            if (getDataBindtype === "URL") {
                if (forms.bind.path !== "") {
                    setErrorFlag(false)
                    onSentSuccessData();
                } else {
                    let forms = formChart.getFieldValue();
                    forms["isValid"] = false;
                    setErrorFlag(true)
                    props._getLayoutData(props.widgetId, forms);
                }
            }
            else {
                if (forms.bind.data !== "") {
                    setErrorFlag(false)
                    onSentSuccessData();
                } else {
                    let forms = formChart.getFieldValue();
                    forms["isValid"] = false;
                    setErrorFlag(true)
                    props._getLayoutData(props.widgetId, forms);
                }
            }
        } else {
            let forms = formChart.getFieldValue();
            let cardData = props.widgetItem;
            if (cardData.widgetData !== null && cardData.widgetData.length > 0) {
                let dataSoruce = cardData.widgetData[0].bind;
                _getPropsForIndex(0, dataSoruce);
                setErrorFlag(false)
                onSentSuccessData();
            } else {
                forms["isValid"] = false;
                setErrorFlag(true)
                props._getLayoutData(props.widgetId, forms);
            }

        }
    }

    const onFinishFailed = () => {
    }

    const onSentSuccessData = () => {
        let forms = formChart.getFieldValue();
        forms["isValid"] = true;
        forms['axisX'] = xaxisData;
        forms['axisY'] = yaxisData
        props._getLayoutData(props.widgetId, forms);
    }

    const _getPropsForIndex = (index, dataSource) => {

        let formData = formChart.getFieldValue();
        formData["widgetType"] = props.widgetType;
        formData["bind"] = dataSource;
        formChart.setFieldsValue(formData)

    }

    return <Card className="widget-data-card  mt-2">
        <CardBody>
            <Form
                form={formChart}
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                layout="vertical"
            >
                <Row>
                    <Col xs={6} className='p-0 pr-3'>
                        <Row className='mb-3'>
                            <Col>
                                <Form.Item name="title" className='col m-0 pl-1' label={<label
                                    className="form-control-label font12"
                                >
                                    Title
                                </label>} rules={[
                                    {
                                        required: false,
                                        message: 'The name is required.'
                                    }
                                ]} >
                                    <Input placeholder='Title' className="select-theme-width" />
                                </Form.Item>
                            </Col>

                            <Col>
                                <Form.Item name="theme" className='col m-0 pl-1' label={<label
                                    className="form-control-label font12"
                                >
                                    Theme
                                </label>} >
                                    <Select className="select-theme-width">
                                        <Select.Option value="light1">Light</Select.Option>
                                        <Select.Option value="dark1">Dark</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item name="width" className='col m-0 pl-1' label={<label
                                    className="form-control-label font12"
                                >
                                    Width
                                </label>} >
                                    <InputNumber className="select-theme-width" />
                                </Form.Item>
                            </Col>
                        </Row><span></span>

                        <Row className='mb-3'>
                            <Col>
                                <Form.Item name="markerSize" className='col m-0 pl-1' label={<label
                                    className="form-control-label font12"
                                >
                                    Marker Size
                                </label>} >
                                    <InputNumber className="select-theme-width" />
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item name="fontSize" className='col m-0 pl-1' label={<label
                                    className="form-control-label font12"
                                >
                                    Font Size
                                </label>} >
                                    <InputNumber className="select-theme-width" />
                                </Form.Item>
                            </Col>

                            <Col>
                                <Form.Item name="dataFrom" className='col m-0 pl-1' label={<label
                                    className="form-control-label font12"
                                >
                                    Data From
                                </label>} >
                                    <Select className='' onChange={onChangeDataBind}>
                                        {dataSoruce.map((item, index) => (
                                            <Select.Option value={item.value} key={index}>{item.label}</Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col>
                                <Form.Item name="animationAngle" className='col m-0 pl-1' label={<label
                                    className="form-control-label font12"
                                >
                                    Animation Angle
                                </label>} >
                                    <InputNumber max={180} className="select-theme-width" />
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item name="animationDuration" className='col m-0 pl-1' label={<label
                                    className="form-control-label font12"
                                >
                                    Animation Duration
                                </label>} >
                                    <InputNumber max={5} className="select-theme-width" />
                                </Form.Item>
                            </Col>
                            <Col className='m-0'></Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col>
                                <Form.Item name="chartOptions" className='col p-0 m-0 pl-1' label={<label
                                    className="form-control-label font12">
                                    Options </label>} >
                                    <Checkbox.Group className='chart-options' style={{ width: '100%' }}>
                                        <Checkbox value="exportEnabled" className="font-weight-normal" >Export Enabled</Checkbox> <br />
                                        <Checkbox value="animationEnabled" className="font-weight-normal">Animation Enabled</Checkbox> <br />
                                        <Checkbox value="showInLegend" className="font-weight-normal">Show Legend</Checkbox>  <br />
                                    </Checkbox.Group>
                                </Form.Item>
                            </Col>
                        </Row>
                    
                    <Row className='p-0'>
                        <Col className='m-0 p-0'>
                            <div>
                                {(props.widgetItem.widgetType === "Line" || props.widgetItem.widgetType === "Spline" || props.widgetItem.widgetType === "Area") &&
                                    <Tabs defaultActiveKey="1" className='col p-0 df-axis'>
                                        <TabPane tab="Xaxis" key="1">
                                            <div className='d-flex axis-width'>
                                                <div className='pl-1'>
                                                    <label className="form-control-label font12">
                                                        Title
                                                    </label>
                                                    <Input placeholder='Title' value={xaxisData.title} name="title" className="select-theme-width" onChange={xAxisonChange} />
                                                </div>
                                                <div className='pl-1'>
                                                    <label className="form-control-label font12">
                                                        Prefix
                                                    </label>
                                                    <Input placeholder='Prefix' value={xaxisData.prefix} name="prefix" className="select-theme-width" onChange={xAxisonChange} />
                                                </div>
                                                <div className='pl-1'>
                                                    <label className="form-control-label font12">
                                                        Suffix
                                                    </label>
                                                    <Input placeholder='Suffix' value={xaxisData.suffix} name="suffix" className="select-theme-width" onChange={xAxisonChange} />
                                                </div>
                                            </div>
                                        </TabPane>
                                        <TabPane tab="Yaxis" key="2">
                                            <div className='d-flex axis-width'>
                                                <div className='pl-1'>
                                                    <label className="form-control-label font12">
                                                        Title
                                                    </label>
                                                    <Input placeholder='Title' value={yaxisData.title} name="title" className="select-theme-width" onChange={yAxisonChange} />
                                                </div>
                                                <div className='pl-1'>
                                                    <label className="form-control-label font12">
                                                        Prefix
                                                    </label>
                                                    <Input placeholder='Prefix' value={yaxisData.prefix} name="prefix" className="select-theme-width" onChange={yAxisonChange} />
                                                </div>
                                                <div className='pl-1'>
                                                    <label className="form-control-label font12">
                                                        Suffix
                                                    </label>
                                                    <Input placeholder='Suffix' value={yaxisData.suffix} name="suffix" className="select-theme-width" onChange={yAxisonChange} />
                                                </div>
                                            </div>
                                        </TabPane>
                                    </Tabs>
                                }
                            </div>
                        </Col>
                    </Row>

                    </Col>

                    <Col className='p-0' xs={6}>
                        <div className='mt-2'>
                            {getDataBindtype === "URL" && <UrlProps widgetIndex={props.widgetIndex} propData={props.widgetItem}
                                _getPropsForIndex={_getPropsForIndex.bind(this)} errorFlag={getErrorFlag} />}

                            {getDataBindtype === "JSON" && <JsonProps widgetIndex={props.widgetIndex} propData={props.widgetItem}
                                _getPropsForIndex={_getPropsForIndex.bind(this)} errorFlag={getErrorFlag} />}

                        </div>
                    </Col>
                </Row>

                <Row className='mt-4 float-right'>
                    <Form.Item className='pl-0 save-btn-widgets' >
                        <Button htmlType="submit" title='Save' className='settings-save-btn'>
                            <SaveOutlined className='icon-style' /> Save
                        </Button>
                    </Form.Item>
                </Row>

            </Form>
        </CardBody>
    </Card>
}
export default ChartRender;
